<template>
  <section
    :class="[
      'modern-filter-toolbar',
      'hc-no-form-icons',
      { 'is-embedded': embedded, 'is-single-line': singleLine }
    ]"
    aria-label="Filter tabel"
  >
    <div class="modern-filter-toolbar__main">
        <div class="modern-period-presets" v-if="showTimeseries" role="group" aria-label="Periode data">
          <button
            v-for="option in periodOptions"
            :key="option.value"
            type="button"
            class="btn-modern-pill"
            :class="{ active: btnActive[option.value] }"
            @click="selectPeriodOption(option.value)"
          >{{ option.label }}</button>
        </div>

        <div v-if="$slots['before-search']" class="modern-filter-additional">
          <slot name="before-search"></slot>
        </div>

        <ModernSearchInput
          v-if="showSearch"
          :value="searchText"
          :placeholder="searchPlaceholder"
          :hint="searchHint"
          @input="$emit('update:searchText', $event)"
          @keyup="$emit('search-keyup', $event)"
        />

        <div v-if="$slots['additional-filters']" class="modern-filter-additional">
          <slot name="additional-filters"></slot>
        </div>

        <div v-if="showPeriod && inlinePeriod" class="modern-filter-period-inline">
          <HcDateRangeFilter
            :start-date="startDate"
            :end-date="endDate"
            @update:startDate="$emit('update:startDate', $event)"
            @update:endDate="$emit('update:endDate', $event)"
            @search="$emit('period-search')"
            @reset="$emit('period-reset')"
          />
        </div>

        <div v-if="$slots['right-period']" class="modern-filter-actions">
          <slot name="right-period"></slot>
        </div>

        <div v-if="$slots['left-period']" class="modern-filter-meta">
          <i class="fas fa-database" aria-hidden="true"></i>
          <slot name="left-period"></slot>
        </div>
      </div>

    <div v-if="showPeriod && !inlinePeriod" class="modern-filter-period">
      <div class="modern-filter-period__content">
        <HcDateRangeFilter
          :start-date="startDate"
          :end-date="endDate"
          @update:startDate="$emit('update:startDate', $event)"
          @update:endDate="$emit('update:endDate', $event)"
          @search="$emit('period-search')"
          @reset="$emit('period-reset')"
        />
      </div>
    </div>
  </section>
</template>

<script>
import HcDateRangeFilter from "@/view/components/ui/HcDateRangeFilter.vue"
import ModernSearchInput from "@/component/general/ModernSearchInput.vue"

export default {
  name: "ModernFilterBar",
  components: {
    HcDateRangeFilter,
    ModernSearchInput
  },
  props: {
    showTimeseries: {
      type: Boolean,
      default: true
    },
    embedded: {
      type: Boolean,
      default: false
    },
    singleLine: {
      type: Boolean,
      default: false
    },
    inlinePeriod: {
      type: Boolean,
      default: false
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    periodOptions: {
      type: Array,
      default: () => [
        { value: "days", label: "Hari Ini" },
        { value: "month", label: "Bulan Ini" },
        { value: "lastMonth", label: "Bulan Kemarin" },
        { value: "year", label: "Tahun Ini" },
        { value: "period", label: "Periode" }
      ]
    },
    btnActive: {
      type: Object,
      required: false,
      default: () => ({ days: true, month: false, lastMonth: false, year: false, period: false })
    },
    searchText: {
      type: String,
      default: ""
    },
    searchPlaceholder: {
      type: String,
      default: "Cari..."
    },
    searchHint: {
      type: String,
      default: ""
    },
    showPeriod: {
      type: Boolean,
      default: false
    },
    startDate: {
      type: String,
      default: ""
    },
    endDate: {
      type: String,
      default: ""
    }
  },
  methods: {
    selectPeriodOption(value) {
      if (value === "period") {
        this.$emit("period-click")
        return
      }
      this.$emit("timeseries-click", value)
    }
  }
}
</script>

<style>
.modern-filter-toolbar {
  --filter-accent: #16867f;
  --filter-accent-dark: #116e6a;
  --filter-border: #dbe4ec;
  --filter-text: #334155;
  --filter-muted: #8a9aab;
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.modern-filter-toolbar.is-embedded {
  padding: 0;
  border: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.modern-filter-toolbar.is-embedded .modern-filter-toolbar__main {
  justify-content: flex-start;
}

.modern-filter-toolbar__main {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.modern-period-presets {
  display: inline-flex;
  align-items: center;
  gap: 0.15rem;
  padding: 0.18rem;
  border: 1px solid var(--filter-border);
  border-radius: 10px;
  background: #f7f9fb;
}

.btn-modern-pill {
  min-height: 34px;
  padding: 0 0.55rem;
  border: 0;
  border-radius: 8px;
  background: transparent;
  color: #526477;
  font-weight: 600;
  font-size: 12px;
  outline: none;
  white-space: nowrap;
}

.btn-modern-pill:hover {
  background: #edf6f7;
}

.btn-modern-pill.active {
  background: var(--filter-accent);
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(22, 134, 127, 0.18);
}

.modern-filter-additional {
  display: flex;
  align-items: center;
  min-width: 0;
}

.modern-filter-select {
  flex: 0 0 230px;
  width: 230px;
  min-width: 230px;
}

.modern-filter-select .vue-treeselect__control {
  width: 100%;
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 0.2rem;
  border: 1px solid var(--filter-border) !important;
  border-radius: 10px !important;
  background: #fff !important;
  box-shadow: none !important;
}

.modern-filter-select .custom-select {
  width: 100%;
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 2rem 0 0.75rem !important;
  border: 1px solid var(--filter-border) !important;
  border-radius: 10px !important;
  background-color: #fff !important;
  color: var(--filter-text) !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

.modern-filter-select .custom-select:focus {
  border-color: var(--filter-accent) !important;
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.09) !important;
}

.modern-filter-select .vue-treeselect--focused .vue-treeselect__control {
  border-color: var(--filter-accent) !important;
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.09) !important;
}

.modern-filter-select .vue-treeselect__placeholder,
.modern-filter-select .vue-treeselect__single-value {
  color: var(--filter-muted);
  font-size: 13px;
  font-weight: 300;
  line-height: 38px;
}

.modern-filter-select .vue-treeselect__single-value {
  color: var(--filter-text);
  font-weight: 400;
}

.modern-filter-select .vue-treeselect__input-container,
.modern-filter-select input.vue-treeselect__input {
  height: 38px !important;
  min-height: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
  line-height: 38px !important;
}

.modern-filter-selector {
  display: inline-flex;
  align-items: center;
  width: 230px;
  height: 40px;
  gap: 0.55rem;
  padding: 0 0.75rem;
  border: 1px solid var(--filter-border);
  border-radius: 10px;
  background: #fff;
  color: var(--filter-text);
  font-size: 13px;
  font-weight: 400;
  text-align: left;
}

.modern-filter-selector i {
  color: var(--filter-accent) !important;
  font-size: 0.86rem;
}

.modern-filter-selector__placeholder {
  color: var(--filter-muted);
  font-weight: 300;
}

.modern-filter-selector:focus {
  outline: 0;
  border-color: var(--filter-accent);
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.09);
}

.modern-filter-meta,
.modern-filter-actions {
  display: inline-flex;
  align-items: center;
  min-height: 40px;
  white-space: nowrap;
}

.modern-filter-meta {
  gap: 0.4rem;
  margin-left: auto;
  padding: 0 0.25rem;
  color: #64748b;
  font-size: 12px;
}

.modern-filter-meta i { color: var(--filter-accent) !important; font-size: 0.84rem; }

.modern-filter-meta span {
  color: #64748b !important;
  font-size: 12px !important;
  font-weight: 600 !important;
}

.modern-filter-period {
  margin-top: 0.7rem;
  padding-top: 0.7rem;
  border-top: 1px solid #edf2f7;
}

.modern-filter-period__content {
  max-width: 760px;
}

.modern-filter-period-inline {
  flex: 1 1 520px;
  min-width: 460px;
}

.btn-modern-teal {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0 0.8rem;
  background: #fff;
  border: 1px solid var(--filter-accent);
  color: var(--filter-accent);
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
}
.btn-modern-teal:hover {
  background: #eef8f7;
  border-color: var(--filter-accent);
  color: var(--filter-accent);
  box-shadow: none;
}

.btn-modern-teal i,
.btn-modern-danger i,
.btn-modern-export i {
  color: var(--filter-accent) !important;
  font-size: 12px;
}

.btn-modern-danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.4rem;
  min-height: 40px;
  padding: 0 0.75rem;
  background: #fff;
  border: 1px solid var(--filter-accent);
  color: var(--filter-accent);
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
}
.btn-modern-danger:hover {
  border-color: var(--filter-accent);
  background: #eef8f7;
  color: var(--filter-accent);
}
.modern-joined-group {
  min-height: 40px;
  gap: 0.4rem;
  box-shadow: none;
  border-radius: 0;
  background: transparent;
}

.patient-birth-date-control {
  position: relative;
  width: 230px;
  height: 40px;
}

.patient-birth-date-control > i {
  position: absolute;
  top: 50%;
  left: 0.75rem;
  z-index: 2;
  transform: translateY(-50%);
  color: var(--filter-accent) !important;
  font-size: 0.86rem;
  pointer-events: none;
}

#kt_content .modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input,
.modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input {
  width: 100%;
  height: 40px !important;
  min-height: 40px !important;
  padding: 0 0.7rem 0 2.25rem !important;
  border: 1px solid var(--filter-border) !important;
  border-radius: 10px !important;
  background: #fff !important;
  color: var(--filter-text) !important;
  box-shadow: none !important;
  font-size: 13px !important;
  font-weight: 400 !important;
}

#kt_content .modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input::placeholder,
.modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input::placeholder {
  color: var(--filter-muted) !important;
  font-weight: 300 !important;
}

#kt_content .modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input:focus,
.modern-filter-toolbar .patient-birth-date-control input.patient-birth-date-input:focus {
  border-color: var(--filter-accent) !important;
  box-shadow: 0 0 0 3px rgba(22, 134, 127, 0.09) !important;
}

.btn-modern-export {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 40px;
  padding: 0 0.8rem;
  background: transparent;
  border: 1px solid var(--filter-accent);
  color: var(--filter-accent);
  border-radius: 10px;
  font-weight: 600;
  font-size: 12px;
}
.btn-modern-export:hover {
  background: transparent;
  color: var(--filter-accent);
}

@media (min-width: 1200px) {
  .modern-filter-toolbar.is-single-line .modern-filter-toolbar__main {
    flex-wrap: nowrap;
    width: 100%;
    gap: 0.4rem;
  }

  .modern-filter-toolbar.is-single-line .modern-period-presets {
    flex: 0 1 auto;
    min-width: 0;
  }

  .modern-filter-toolbar.is-single-line .btn-modern-pill {
    padding-right: 0.45rem;
    padding-left: 0.45rem;
    font-size: 12px;
  }

  .modern-filter-toolbar.is-single-line .modern-filter-additional {
    flex: 0 1 190px;
    min-width: 150px;
  }

  .modern-filter-toolbar.is-single-line .modern-filter-select {
    flex: 1 1 190px;
    width: 100%;
    min-width: 150px;
  }

  .modern-filter-toolbar.is-single-line .modern-search-box {
    flex: 1 1 190px;
    width: auto;
    min-width: 160px;
    max-width: 230px;
  }

  .modern-filter-toolbar.is-single-line .modern-filter-actions {
    flex: 0 0 auto;
    margin-left: auto;
  }

  .modern-filter-toolbar.is-single-line .modern-filter-period-inline {
    flex: 1 1 500px;
    min-width: 430px;
  }

  #kt_content .modern-filter-toolbar.is-single-line .modern-filter-period-inline .hc-date-range-filter {
    padding: 0;
    border: 0;
    background: transparent;
  }
}

@media (max-width: 991.98px) {
  .modern-period-presets {
    width: 100%;
    overflow-x: auto;
  }

  .modern-filter-meta {
    margin-left: 0;
  }

  .modern-filter-select {
    flex: 1 1 230px;
    width: auto;
    min-width: 190px;
  }

  .modern-filter-period-inline {
    flex-basis: 100%;
    min-width: 0;
  }
}

@media (max-width: 575.98px) {
  .modern-filter-toolbar { padding: 0; }
  .modern-filter-additional,
  .modern-filter-additional > *,
  .modern-joined-group { width: 100%; }
  .modern-filter-select { width: 100%; min-width: 0; }
  .patient-birth-date-control { flex: 1; width: auto; }
}
</style>
